var map = {
	"./collect.png": "0fb3",
	"./collectActive.png": "c566",
	"./comment.png": "368e",
	"./devImg/avatar.png": "9b9b",
	"./devImg/bg.png": "9ee3",
	"./folloIcon.png": "829d",
	"./like.png": "6257",
	"./redLike.png": "fad4",
	"./share.png": "611d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a41";